// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__lLf+m","tyre":"style_tyre__yQep0"};